import React from "react";

function About() {
  return (
    <section className="bg-white border-b py-8" id="about">
      <div className="container max-w-5xl mx-auto m-8">
        <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">Hello there!</h1>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"/>
        </div>
        <div className="flex flex-wrap">
          <div className="w-full text-gray-600 mb-8 prose max-w-none">
            <p>
              With the release of the RTX 3000 series many people started using bots to gain an unfair advantage in getting one of the insanely limited stock. Those bots are faster, don&apos;t rely
              on human interaction in order to get what they want and often times even completed the entire checkout process for their users, making it nearly impossible for non-bot users to even
              purchase one of those shiny, new GPUs, consoles, etc..
            </p>
            <img src="https://i.redd.it/bg3l47ccwpn51.jpg" className="mx-auto"/>
            <p>
              <b>ilox</b> (<i>i love X</i>) was started to help people by providing
              tools that are free and available for <b>everyone</b> without technical knowledge. With thousands of Discord members who try to help each other in notifying about stock changes and the
              help of automated tracking bots (which are kept as lightweight as possible towards shop servers by having low polling frequencies and not trying to hack around implemented
              shop securities like captchas, etc.) we&apos;ve helped countless people in getting a new console, new graphic cards and more.
            </p>
            <p>
              We are <b>strictly against</b> systematic buying / selling, selling far over MSRP or, in short, scalping and instead try to equalize chances for everyone at fair prices. This&nbsp;
              <i>scarcity</i> is partially due to people who just want to make a quick buck at the expense of people who just want to enjoy new games or better hardware for their work -
              and, lets be honest here, that&apos;s a pretty <i>shitty</i> thing to do.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
